import React, { Component } from "react";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import { CommonSuccessMessages, CommonValidationMessages } from "../../utils/Messages.js";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import moment from "moment";
import ModalBasic from "../component/ModalBasic.js";
import DateRangePickerSelect from "../../components/TimePicker.js/DateRangePickerSelect.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class GRNRawMaterial extends Component {
  constructor(props) {
    super(props);
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isGridView: true,
      isEditing: false,
      tableStatus: "",
      isLoading: false,
      setPurchaseMaterialModal: false,
      isMaterialDetailsEditing: false,
      isMaterialDetailsHide: true,
      isFromPurchaseMaterial: false,
      purchaseOrderTextGreen: "",
      purchaseOrderTextRed: "",
      partyDropdownList: [],
      grnEntryPartyList: [],
      grnEntryMaterialList: [],
      packingMaterialDropDownList: [],
      purchaseOrderMaterialList: [],
      partyDetailsId: "",
      materialDetailsId: "",
      filterDetails: {
        partyName: "",
        filterBy: "",
        materialType: ""
      },
      grnRawMaterialPartyDetails: {
        grnEntryType: "",
        partyId: "",
        invoiceNo: "",
        invoiceDate: "",
        grnNo: "",
      },
      grnMaterialDetails: {
        rawMaterialId: "",
        uom: "",
        packageMaterialId: "",
        batchNo: "",
        qty: '',
        rate: '',
        amount: '0',
        mfgBy: "",
        mfgDate: "",
        expDate: "",
        packing: "",
        isPurchaseOrderEntry: false,
        purchaseOrderId: null,
        purchaseOrdermaterialId: null
      },
      rawMaterialList: [],
      filterByList: [
        { filterBy: 'GRN No.', value: 'grnNo' },
        { filterBy: 'GRN Date', value: 'grnDate' },
        { filterBy: 'Invoice No.', value: 'invoiceNo' },
        { filterBy: 'Party Name', value: 'partyName' }
      ],
      typeList: [
        { grnType: 'Raw' },
        { grnType: 'Packing' },
      ],
      validationRules: {
        partyId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "party name"
            ),
          },
        ],
        invoiceNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "invoice No"
            ),
          },
        ],
        invoiceDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "invoice date"
            ),
          },
        ],
        grnEntryType: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "Material Type"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRulesForMaterials: {
        // packing: [
        //   {
        //     type: "require",
        //     message: CommonValidationMessages.FieldRequired.replace(
        //       "{0}",
        //       "packing"
        //     ),
        //   },
        // ],
        rate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "rate"
            ),
          },
          // {
          //   type: "number",
          //   message: CommonValidationMessages.FieldRequired.replace(
          //     "{0}",
          //     "rate"
          //   ),
          // },
        ],
        qty: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "qty"
            ),
          },
          // {
          //   type: "number",
          //   message: CommonValidationMessages.FieldRequired.replace(
          //     "{0}",
          //     "qty"
          //   ),
          // },
        ],
      },
      rawMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "raw material"
          ),
        },
      ],
      packageMaterialIdRule: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "package material"
          ),
        },
      ],
      validStateForMaterials: {
        isValid: true,
        error: {},
      },
      batchNo: [
        {
          type: "require",
          message: CommonValidationMessages.FieldRequired.replace(
            "{0}",
            "batch no"
          ),
        },
      ],
      mfgBy: [
        {
          type: "require",
          message: CommonValidationMessages.FieldRequired.replace(
            "{0}",
            "mfg By"
          ),
        },
      ],
      mfgDate: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "mfg date"
          ),
        },
      ],
      expDate: [
        {
          type: "require",
          message: CommonValidationMessages.SelectRequired.replace(
            "{0}",
            "expiry date"
          ),
        },
      ],
    };
  }

  componentDidMount() {
    this.getAllPartyListForGRNEntry();
  }

  getAllPartyListForGRNEntry = () => {
    this.setState({ tableStatus: "Loading..." })
    let request = this.state.filterDetails
    this.inventoryServices.getAllPartyListForGRNEntry(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        if (response.responseData.length === 0) {
          this.setState({ tableStatus: "No Record Found" })
        } else {
          this.setState({ tableStatus: "" })
        }
        let res = response.responseData;
        this.setState({ grnEntryPartyList: res }, () => {
          this.getAllPartyDropdown()
        });
      } else {
        this.setState({ tableStatus: "" })
        this.getAllPartyDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllRMDropdown()
        });
      } else {
        this.getAllRMDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.getAllPackingMaterialDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems }, () => { });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getGRNNo = () => {
    this.inventoryServices.getGRNNo().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = this.state.grnRawMaterialPartyDetails
        details.grnNo = response.responseData.grnNo
        this.setState({ grnRawMaterialPartyDetails: details });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  closeGridView = () => {
    this.setState({ isGridView: false });
  };

  openGridView = () => {
    this.resetForm();
    this.setState({ isGridView: true, isEditing: false });
  };

  setFilterParameters = (selected, drpIdentity, section) => {
    let details = this.state.grnRawMaterialPartyDetails
    let details1 = this.state.grnMaterialDetails
    if (section === 'grnMaterialDetails') {
      details[drpIdentity] = selected.value
      this.setState({ grnRawMaterialPartyDetails: details }, () => {
        this.isAllFieldsValidate()
      });
    }
    if (section === 'RawMaterialDetails') {
      details1[drpIdentity] = selected.value
      if (drpIdentity === 'rawMaterialId' || drpIdentity === 'packageMaterialId') {
        details1.uom = selected.uom
      }
      this.setState({ grnMaterialDetails: details1 }, () => {
        this.getPurchaseOrderMaterialByPartyId()
      });
    }
  };

  handleChange = (event, name, section) => {
    let value = event.target.value;
    if (section === 'PartyDetails') {
      let details = this.state.grnRawMaterialPartyDetails;
      details[name] = value.toUpperCase();
      this.setState({ grnRawMaterialPartyDetails: details }, () => {
        this.isAllFieldsValidate()
      })
    } else if (section === 'filterDetails') {
      let details = this.state.filterDetails;
      details[name] = value.toUpperCase();
      this.setState({ filterDetails: details }, () => {
        this.getAllPartyListForGRNEntry()
      });
    } else {
      let details = this.state.grnMaterialDetails;
      details[name] = value.toUpperCase();
      this.setState({ grnMaterialDetails: details });
    }
  };

  handleChangeForDatePicker = (date, name) => {
    let details = this.state.grnMaterialDetails;
    details[name] = date;
    this.setState({ grnMaterialDetails: details });
  }

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.grnRawMaterialPartyDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    if (newValidState.isValid) {
      this.setState({ isMaterialDetailsHide: false })
    } else {
      this.setState({ isMaterialDetailsHide: true })
    }
  }

  addEditGRNEntryMaterialMapping = () => {
    let isValidAllFields = this.isValidAllFields()
    if (isValidAllFields) {
      this.setState({ isLoading: true }, () => {
        let request = {};
        request.grnRawMaterialPartyDetails = this.state.grnRawMaterialPartyDetails
        request.grnMaterialDetails = this.state.grnMaterialDetails
        request.grnMaterialDetails.amount = this.state.grnMaterialDetails.qty * this.state.grnMaterialDetails.rate

        if (this.state.grnRawMaterialPartyDetails.grnEntryType === 'Raw') {
          delete request.grnMaterialDetails.packageMaterialId
        } else {
          delete request.grnMaterialDetails.rawMaterialId
        }

        if (this.state.partyDetailsId && this.state.partyDetailsId !== "") {
          request.grnRawMaterialPartyDetails.partyDetailsId = this.state.partyDetailsId;
        } else {
          delete request.grnRawMaterialPartyDetails.partyDetailsId;
        }

        if (this.state.materialDetailsId && this.state.materialDetailsId !== "") {
          request.grnMaterialDetails.materialDetailsId = this.state.materialDetailsId;
        } else {
          delete request.grnMaterialDetails.materialDetailsId;
        }

        this.inventoryServices.addEditGRNEntryMaterialMapping(request).then((response) => {
          if (response.statusCode === 200 && response.responseData !== null) {
            this.SwalServices.Success(response.Message)
            this.setState({ partyDetailsId: response.responseData.partyDetails._id }, () => {
              this.resetMaterialDetalis()
              this.getAllgrnEntryMaterialDetailsById(this.state.partyDetailsId)
              this.setState({ isLoading: false })
            })
          } else {
            this.SwalServices.Error(response.Message);
            this.setState({ isLoading: false })
          }
        })
      })
    }
  }

  isValidAllFields = () => {

    const validationRule = this.state.validationRulesForMaterials

    if (this.state.grnRawMaterialPartyDetails.grnEntryType === 'Raw') {
      validationRule.rawMaterialId = this.state.rawMaterialIdRule
      validationRule.packageMaterialId = []
      // validationRule.batchNo = this.state.batchNo
      // validationRule.mfgDate = this.state.mfgDate
      // validationRule.expDate = this.state.expDate
      // validationRule.mfgBy = this.state.mfgBy
    } else {
      validationRule.packageMaterialId = this.state.packageMaterialIdRule
      validationRule.rawMaterialId = []
      validationRule.batchNo = []
      validationRule.mfgDate = []
      validationRule.expDate = []
      validationRule.mfgBy = []
    }

    const newValidState = isValidForm(
      this.state.grnMaterialDetails,
      validationRule,
      this.state.validStateForMaterials
    );
    this.setState({ validStateForMaterials: newValidState });
    return newValidState.isValid;
  };

  handleDropdownChange = (e, name, section) => {
    const value = e.target.value;
    if (section === "ParyDetails") {
      let details = this.state.grnRawMaterialPartyDetails
      details[name] = value;
      this.setState({ grnRawMaterialPartyDetails: details }, () => {
        this.isAllFieldsValidate()
      })
    } else {
      let details = this.state.filterDetails;
      details[name] = value;
      this.setState({ filterDetails: details }, () => {
        this.getAllPartyListForGRNEntry()
      });
    }
  };

  editGRNEntryMaterialDetails = (materialDetail) => {
    let details = this.state.grnRawMaterialPartyDetails
    details.partyId = materialDetail.partyId._id
    details.grnEntryType = materialDetail.grnEntryType
    details.invoiceNo = materialDetail.invoiceNo
    details.grnNo = materialDetail.grnNo
    details.invoiceDate = moment(materialDetail.invoiceDate).format('yyyy-MM-DD')
    this.setState({ grnRawMaterialPartyDetails: details, partyDetailsId: materialDetail._id }, () => {
      this.getAllgrnEntryMaterialDetailsById(materialDetail._id)
    })
  }

  getAllgrnEntryMaterialDetailsById = (id) => {
    this.inventoryServices.getAllgrnEntryMaterialDetailsById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        this.setState({ grnEntryMaterialList: details }, () => {
          this.isAllFieldsValidate()
          this.setState({ isGridView: false, isEditing: true })
        })
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  }

  deleteGRNEntryMaterialDetailsById = (id) => {
    this.SwalServices.Confirm(
      "",
      ``,
      CommonSuccessMessages.Yes_Text,
      CommonSuccessMessages.No_Text,
      `Are you sure you want to delete?`
    ).then((response) => {
      if (response === true) {
        this.inventoryServices.deleteGRNEntryMaterialDetailsById(id).then((response) => {
          if (response.statusCode === 200 && response.responseData != null) {
            this.getAllPartyListForGRNEntry()
            this.SwalServices.Success(response.Message);
          } else {
            this.SwalServices.Error(response.Message);
          }
        })
      }
    })
  }
  resetFilterDetails = () => {
    let filterDetails = this.state.filterDetails
    filterDetails.partyName = ""
    filterDetails.filterBy = ""
    filterDetails.materialType = ""
    this.setState({ filterDetails: filterDetails })
  }
  resetPartyDetails = () => {

    let details = this.state.grnRawMaterialPartyDetails
    details.grnEntryType = ""
    details.partyId = ""
    details.invoiceNo = ""
    details.invoiceDate = ""
    this.setState({ grnRawMaterialPartyDetails: details })
  }

  resetMaterialDetalis = () => {
    let validState = this.state.validStateForMaterials
    validState.isValid = true
    validState.error = {}
    let details = this.state.grnMaterialDetails
    details.rawMaterialId = ""
    details.packageMaterialId = ""
    details.batchNo = ""
    details.qty = ''
    details.rate = ''
    details.amount = ''
    details.mfgBy = ""
    details.mfgDate = ""
    details.expDate = ""
    details.packing = ""
    this.setState({
      grnMaterialDetails: details, materialDetailsId: "", isMaterialDetailsEditing: false, isFromPurchaseMaterial: false,
      purchaseOrderTextGreen: "",
      purchaseOrderTextRed: "",
      validState: validState
    })
  }

  resetForm = () => {
    this.resetFilterDetails()
    this.resetMaterialDetalis()
    this.resetPartyDetails()
    this.setState({ isGridView: true, isEditing: false, partyDetailsId: '', isMaterialDetailsHide: true, tableStatus: "", grnEntryMaterialList: [] }, () => {
      this.getAllPartyListForGRNEntry()
    })
  }

  getGRNMaterialDetailsById = (details) => {
    let materialDetails = this.state.grnMaterialDetails
    materialDetails.rawMaterialId = details.rawMaterialId ? details.rawMaterialId._id : ''
    materialDetails.packageMaterialId = details.packageMaterialId ? details.packageMaterialId._id : ''
    materialDetails.uom = details.packageMaterialId ? details.packageMaterialId.pmUOM : details.rawMaterialId.rmUOM
    materialDetails.batchNo = details.batchNo
    materialDetails.qty = details.qty
    materialDetails.rate = details.rate
    materialDetails.amount = details.amount
    materialDetails.mfgBy = details.mfgBy
    materialDetails.mfgDate = details.mfgDate ? moment(details.mfgDate).format('YYYY-MM') : ''
    materialDetails.expDate = details.expDate ? moment(details.expDate).format('YYYY-MM') : ''
    materialDetails.packing = details.packing
    materialDetails.isPurchaseOrderEntry = details.isPurchaseOrderEntry
    if (details.purchaseOrderId || details.purchaseOrdermaterialId) {
      this.setState({
        isFromPurchaseMaterial: true,
        purchaseOrderTextGreen: "This material is being taken from purchase order.",
        purchaseOrderTextRed: ""
      })
    }

    this.setState({ grnMaterialDetails: materialDetails, materialDetailsId: details._id, isMaterialDetailsEditing: true })
  }

  deleteItemforGRNEntryMaterialById = (id) => {
    this.inventoryServices.deleteItemforGRNEntryMaterialById(id).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        this.getAllgrnEntryMaterialDetailsById(this.state.partyDetailsId)
        this.SwalServices.Success(response.Message);
      } else {
        this.SwalServices.Error(response.Message);
      }
    })
  }

  getPurchaseOrderMaterialByPartyId = () => {
    let request = {
      partyId: this.state.grnRawMaterialPartyDetails.partyId,
      materialId: this.state.grnRawMaterialPartyDetails.grnEntryType === 'Raw' ? this.state.grnMaterialDetails.rawMaterialId : this.state.grnMaterialDetails.packageMaterialId,
      materialType: this.state.grnRawMaterialPartyDetails.grnEntryType
    }
    this.inventoryServices.getPurchaseOrderMaterialByPartyId(request).then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let details = response.responseData;
        if (details.length > 0) {
          this.setState({ purchaseOrderMaterialList: details }, () => {
            this.setState({ setPurchaseMaterialModal: true })
          })
        } else {
          this.setState({
            isFromPurchaseMaterial: false,
            purchaseOrderTextGreen: "",
            purchaseOrderTextRed: "There is not any purchase order for this material."

          })
        }
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  }

  setOpenModel = () => {
    this.setState({ setPurchaseMaterialModal: !this.state.setPurchaseMaterialModal });
  };

  purchaseOrderMaterialDetails = (material) => {
    let details = this.state.grnMaterialDetails
    details.qty = material.materialQty
    details.rate = material.materialRate
    details.amount = material.materialAmount
    details.isPurchaseOrderEntry = material.isPurchaseOrderEntry
    details.purchaseOrderId = material.purchaseOrderId ? material.purchaseOrderId : ''
    details.purchaseOrdermaterialId = material.purchaseOrdermaterialId ? material.purchaseOrdermaterialId : ''
    details.mfgBy = material.make
    this.setState({ grnMaterialDetails: details }, () => {
      this.setState({
        setPurchaseMaterialModal: false, isFromPurchaseMaterial: true,
        purchaseOrderTextGreen: "This material is being taken from purchase order.",
        purchaseOrderTextRed: ""
      })
    })
  }

  render() {
    return (
      <>
        <div className="grnRawAndPackMaterial-page">
          {this.state.isGridView === true ? (
            <>
              <div className="item-search mb-3.5">
                <div className="item-grp !flex !gap-2.5">
                  <div className="search-grp !w-[60%]">
                    <div className="item-search-box">
                      <label>Party Name</label>
                      <input
                        className="inputFocus"
                        type="text"
                        id="partyName"
                        name="partyName"
                        autoComplete="off"
                        value={this.state.filterDetails.partyName}
                        onChange={(event) =>
                          this.handleChange(event, "partyName", "filterDetails")
                        }
                      />
                    </div>
                  </div>
                  <div className="dropdown-grp !w-[20%]">
                    <label>Filter by</label>
                    <select
                      name="filterBy"
                      value={this.state.filterDetails.filterBy}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "filterBy")
                      }
                    >
                      <option>Select</option>
                      {this.state.filterByList.map((x, key) => (
                        <option key={key} value={x.value}>
                          {x.filterBy}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="dropdown-grp !w-[20%]" >
                    <label>GRN Material Type</label>
                    <select
                      name="materialType"
                      value={this.state.filterDetails.materialType}
                      onChange={(e) =>
                        this.handleDropdownChange(e, "materialType")
                      }
                    >
                      <option>Select</option>
                      {this.state.typeList.map((x, key) => (
                        <option key={key} value={x.grnType}>
                          {x.grnType}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button className="add-btn mt-3.5" onClick={() => { this.closeGridView(); this.getGRNNo() }}>
                  Add new Item
                </button>
              </div>
              <div className="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 185px)" }}>
                  <table className="itemList">
                    <thead>
                      <tr>
                        <td style={{ width: '10%' }}>GRN No</td>
                        <td style={{ width: '12%' }}>GRN Date</td>
                        <td style={{ width: '15%' }}>Invoice No.</td>
                        <td style={{ width: '40%' }}>Party Name</td>
                        <td style={{ width: '13%' }}>Material Type</td>
                        <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                      </tr>
                    </thead>
                    {this.state.grnEntryPartyList && this.state.grnEntryPartyList.length > 0 ? (
                      this.state.grnEntryPartyList.map((item, key) => (
                        <tbody key={key}>
                          <tr>
                            <td>{item.grnNo}</td>
                            <td>{moment(item.grnDate).format('DD MMM yyyy')}</td>
                            <td>{item.invoiceNo}</td>
                            <td>{item.partyId?.partyName}</td>
                            <td>{item.grnEntryType}</td>
                            <td style={{ textAlign: 'center' }}>
                              <button
                                className="search-btn"
                                onClick={() => this.editGRNEntryMaterialDetails(item)}
                              >
                                <FontAwesomeIcon icon={faPen} />
                              </button>
                              <button
                                className="cancel-btn ml-"
                                onClick={() =>
                                  this.deleteGRNEntryMaterialDetailsById(item._id)
                                }
                                disabled={item.isGSTPurchaseEntryRMPM}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      ))
                    ) : this.state.grnEntryPartyList &&
                      this.state.grnEntryPartyList.length === 0
                      && this.state.tableStatus !== "" ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                          {this.state.tableStatus}
                        </td>
                      </tr>
                    ) : this.state.grnEntryPartyList &&
                      this.state.grnEntryPartyList.length === 0
                      && this.state.tableStatus === "" ? null : ""}
                  </table>
                </div>
              </div>
            </>
          ) : null}
          {this.state.isGridView === false ? (
            <div className="item-listing">
              <div className="item-form">
                <div className="form-table">
                  <div className="item-grp !mb-3">

                    <div className="text-lg font-bold mb-[10px] text-gray-700">
                      Party Details
                    </div>
                    <div className="item-inner-grp !flex gap-2.5 ">
                      <div className="input-grp !min-w-[5%]">
                        <label>GRN No.</label>
                        <input
                          type="text"
                          id="grnNo"
                          name="grnNo"
                          autoComplete="off"
                          disabled
                          className="inputFocus"
                          // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                          value={this.state.grnRawMaterialPartyDetails.grnNo}
                          onChange={(event) =>
                            this.handleChange(event, "grnNo", 'PartyDetails')
                          }
                        />
                      </div>
                      <div className="input-grp !w-full">
                        <label>Party Name</label>
                        <MultiSelectDropdown
                          drpIdentity="partyId"
                          options={this.state.partyDropdownList}
                          closeMenuOnSelect={true}
                          hideSelectedOptions={false}
                          onChange={(selected) =>
                            this.setFilterParameters(selected, "partyId", "grnMaterialDetails")
                          }
                          allowSelectAll={false}
                          value={this.state.partyDropdownList.filter(
                            (party) =>
                              party.value === this.state.grnRawMaterialPartyDetails.partyId
                          )}
                          isDisabled={this.state.isEditing}
                        />
                      </div>
                      <div className="input-grp !min-w-[20%]">
                        <label>Invoice No.</label>
                        <input
                          type="text"
                          id="invoiceNo"
                          name="invoiceNo"
                          autoComplete="off"
                          disabled={!this.state.isMaterialDetailsEditing && this.state.isEditing}
                          className="inputFocus"
                          // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                          value={this.state.grnRawMaterialPartyDetails.invoiceNo}
                          onChange={(event) =>
                            this.handleChange(event, "invoiceNo", 'PartyDetails')
                          }
                        />
                      </div>
                      <div className="input-grp !min-w-[20%]">
                        <label>Invoice Date</label>
                        <input
                          type="date"
                          id="invoiceDate"
                          name="invoiceDate"
                          autoComplete="off"
                          disabled={!this.state.isMaterialDetailsEditing && this.state.isEditing}
                          className="inputFocus"
                          // className={`inputFocus ${this.state.isEditing ? 'disable-input' : ''}`}
                          value={this.state.grnRawMaterialPartyDetails.invoiceDate}
                          onChange={(event) =>
                            this.handleChange(event, "invoiceDate", 'PartyDetails')
                          }
                        />
                      </div>
                      <div className="dropdown-grp !min-w-[15%]">
                        <label>Material Type</label>
                        <select
                          name="grnEntryType"
                          disabled={this.state.isEditing}
                          // className={`${this.state.isEditing ? 'disable-input' : ''}`}
                          value={this.state.grnRawMaterialPartyDetails.grnEntryType}
                          onChange={(e) =>
                            this.handleDropdownChange(e, "grnEntryType", "ParyDetails")
                          }
                        >
                          <option>Select</option>
                          {this.state.typeList.map((x, key) => (
                            <option key={key} value={x.grnType}>
                              {x.grnType}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="item-grp mt-2 grid">
                    <div
                      style={{
                        fontSize: "17px",
                        fontWeight: "700",
                        marginBottom: "12px",
                        color: "#4b4b4b"
                      }}
                    >
                      Material Details
                    </div>
                    <div className="item-inner-grp mb-3 flex gap-2.5">
                      <div className="input-grp w-[40%]">
                        <label>Material Name</label>
                        {this.state.grnRawMaterialPartyDetails.grnEntryType === 'Raw' ?
                          <>
                            <MultiSelectDropdown
                              className={` ${this.state.validStateForMaterials?.error?.rawMaterialId ? "errorInput" : ""}`}
                              drpIdentity="rawMaterialId"
                              options={this.state.rawMaterialList}
                              closeMenuOnSelect={true}
                              hideSelectedOptions={false}
                              onChange={(selected) =>
                                this.setFilterParameters(selected, "rawMaterialId", "RawMaterialDetails")
                              }
                              allowSelectAll={false}
                              value={this.state.rawMaterialList.filter(
                                (party) =>
                                  party.value === this.state.grnMaterialDetails.rawMaterialId
                              )}
                              isDisabled={this.state.isMaterialDetailsHide || this.state.isFromPurchaseMaterial}
                            />
                            {/* <ValidationText
                              error={this.state.validStateForMaterials.error.rawMaterialId}
                            /> */}
                          </>
                          :
                          <>
                            <MultiSelectDropdown
                              className={` ${this.state.validStateForMaterials?.error?.packageMaterialId ? "errorInput" : ""}`}
                              drpIdentity="packageMaterialId"
                              options={this.state.packingMaterialDropDownList}
                              closeMenuOnSelect={true}
                              hideSelectedOptions={false}
                              onChange={(selected) =>
                                this.setFilterParameters(selected, "packageMaterialId", "RawMaterialDetails")
                              }
                              allowSelectAll={false}
                              value={this.state.packingMaterialDropDownList.filter(
                                (party) =>
                                  party.value === this.state.grnMaterialDetails.packageMaterialId
                              )}
                              isDisabled={this.state.isMaterialDetailsHide || this.state.isFromPurchaseMaterial}
                            />
                            {/* <ValidationText
                              error={this.state.validStateForMaterials.error.packageMaterialId}
                            /> */}
                          </>
                        }

                      </div>
                      <div className="input-grp !w-[15%]">
                        <label>Batch No.</label>
                        <input
                          type="text"
                          id="batchNo"
                          name="batchNo"
                          autoComplete="off"
                          disabled={this.state.isMaterialDetailsHide}
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.batchNo ? "errorInput" : ""}`}
                          // className={`inputFocus ${this.state.isMaterialDetailsHide ? 'disable-input' : ''}`}
                          value={this.state.grnMaterialDetails.batchNo}
                          onChange={(event) =>
                            this.handleChange(event, "batchNo")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.batchNo}
                        /> */}
                      </div>
                      <div className="input-grp !w-[15%]">
                        <label>Quantity</label>
                        <input
                          type="number"
                          id="qty"
                          name="qty"
                          autoComplete="off"
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.qty ? "errorInput" : ""}`}
                          disabled={(this.state.isMaterialDetailsHide || this.state.isFromPurchaseMaterial)}
                          value={this.state.grnMaterialDetails.qty}
                          onBlur={(event) => this.setState({ grnMaterialDetails: { ...this.state.grnMaterialDetails, qty: event.target.value || '0' } })}
                          onChange={(event) =>
                            this.handleChange(event, "qty")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.qty}
                        /> */}
                      </div>
                      <div className="input-grp !w-[15%]">
                        <label>UOM</label>
                        <input
                          type="text"
                          id="uom"
                          name="uom"
                          autoComplete="off"
                          className={`inputFocus`}
                          disabled
                          value={this.state.grnMaterialDetails.uom}
                          onChange={(event) =>
                            this.handleChange(event, "uom")
                          }
                        />
                      </div>
                      <div className="input-grp !w-[15%]">
                        <label>Rate</label>
                        <input
                          type="number"
                          id="rate"
                          name="rate"
                          autoComplete="off"
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.rate ? "errorInput" : ""}`}
                          disabled={(this.state.isMaterialDetailsHide || this.state.isFromPurchaseMaterial)}

                          onBlur={(event) => this.setState({ grnMaterialDetails: { ...this.state.grnMaterialDetails, rate: event.target.value || '0' } })}
                          value={this.state.grnMaterialDetails.rate}
                          onChange={(event) =>
                            this.handleChange(event, "rate")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.rate}
                        /> */}
                      </div>
                      <div className="input-grp !w-[15%]">
                        <label>Amount</label>
                        <input
                          type="number"
                          id="amount"
                          name="amount"
                          autoComplete="off"
                          disabled
                          className="inputFocus"
                          value={(this.state.grnMaterialDetails.qty * this.state.grnMaterialDetails.rate).toFixed(2) || '0'}
                          onChange={(event) =>
                            this.handleChange(event, "amount")
                          }
                        />
                      </div>
                    </div>
                    <div className="item-inner-grp flex gap-2.5 mb-2.5">
                      <div className="input-grp !w-[38.95%]">
                        <label>Mfg. By</label>
                        <input
                          type="text"
                          id="mfgBy"
                          name="mfgBy"
                          autoComplete="off"
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.mfgBy ? "errorInput" : ""}`}
                          disabled={this.state.isMaterialDetailsHide}

                          value={this.state.grnMaterialDetails.mfgBy}
                          onChange={(event) =>
                            this.handleChange(event, "mfgBy")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.mfgBy}
                        /> */}
                      </div>
                      {/* <div className="input-grp !w-[14.6%]">
                        <label>Mfg Date</label>
                        <input
                          type="month"
                          id="mfgDate"
                          name="mfgDate"
                          autoComplete="off"
                          // className={`inputFocus ${this.state.isMaterialDetailsHide ? 'disable-input' : ''}`}
                          disabled={this.state.isMaterialDetailsHide}
                          className="inputFocus"
                          value={this.state.grnMaterialDetails.mfgDate}
                          onChange={(event) =>
                            this.handleChange(event, "mfgDate")
                          }
                        />
                        <ValidationText
                          error={this.state.validStateForMaterials.error.mfgDate}
                        />
                      </div> */}
                      <div className="input-grp !w-[14.6%]">
                        <label>Mfg. Date</label>
                        <DatePicker
                          selected={this.state.grnMaterialDetails.mfgDate}
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.mfgDate ? "errorInput" : ""}`}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          onChange={(date) => this.handleChangeForDatePicker(date, "mfgDate")}
                          disabled={this.state.isMaterialDetailsHide}
                        />
                        {/* <ValidationText error={this.state.validStateForMaterials.error.mfgDate} /> */}
                      </div>
                      {/* <div className="input-grp !w-[14.6%]">
                        <label>Exp. Date</label>
                        <input
                          type="month"
                          id="expDate"
                          name="expDate"
                          autoComplete="off"
                          // className={`inputFocus ${this.state.isMaterialDetailsHide ? 'disable-input' : ''}`}
                          min={this.state.grnMaterialDetails.mfgDate}
                          disabled={this.state.isMaterialDetailsHide}
                          className="inputFocus"
                          value={this.state.grnMaterialDetails.expDate}
                          onChange={(event) =>
                            this.handleChange(event, "expDate")
                          }
                        />
                        <ValidationText
                          error={this.state.validStateForMaterials.error.expDate}
                        />
                      </div> */}

                      <div className="input-grp !w-[14.6%]">
                        <label>Exp. Date</label>
                        <DatePicker
                          selected={this.state.grnMaterialDetails.expDate}
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.expDate ? "errorInput" : ""}`}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          onChange={(date) => this.handleChangeForDatePicker(date, "expDate")}
                          disabled={this.state.isMaterialDetailsHide}
                        />
                        {/* <ValidationText error={this.state.validStateForMaterials.error.expDate} /> */}
                      </div>
                      <div className="input-grp !w-[14.7%]">
                        <label>Packing</label>
                        <input
                          type="text"
                          id="packing"
                          name="packing"
                          autoComplete="off"
                          className={`inputFocus ${this.state.validStateForMaterials?.error?.packing ? "errorInput" : ""}`}
                          disabled={this.state.isMaterialDetailsHide}

                          value={this.state.grnMaterialDetails.packing}
                          onChange={(event) =>
                            this.handleChange(event, "packing")
                          }
                        />
                        {/* <ValidationText
                          error={this.state.validStateForMaterials.error.packing}
                        /> */}
                      </div>
                    </div>

                    {/* {this.state.purchaseOrderTextGreen !== "" ? <p className="text-green-700 text-sm">{this.state.purchaseOrderTextGreen}</p> : null}
                    {this.state.purchaseOrderTextRed !== "" ? <p className="text-red-700 text-sm">{this.state.purchaseOrderTextRed}</p> : null} */}


                    <div className="btn-grp mb-3">
                      {this.state.isMaterialDetailsEditing === true ? (
                        <button
                          className="add-btn"
                          disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                          onClick={() => this.addEditGRNEntryMaterialMapping()}
                        >
                          {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                        </button>
                      ) : (
                        <button
                          className="add-btn"
                          disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                          onClick={() => this.addEditGRNEntryMaterialMapping()}
                        >
                          {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Add"}
                        </button>
                      )}
                      <button
                        disabled={this.state.isLoading || this.state.isMaterialDetailsHide}
                        className="cancel-btn"
                        onClick={() => { this.resetMaterialDetalis(); this.setState({ rawMaterialId: "" }); }}
                      >
                        Cancel
                      </button>
                      <button
                        className="back-btn"
                        disabled={this.state.isLoading}
                        onClick={() => this.openGridView()}
                      >
                        Back
                      </button>
                      {this.state.purchaseOrderTextGreen !== "" ? <p
                        className='  w-fit p-2 rounded-[8px] mt-auto mb-auto'
                        style={{
                          color: "#15803d",
                          fontSize: "13px",
                          border: "1px solid #15803d73",
                          outline: " 2px solid rgb(21 128 61 / 13%)",
                        }}>{this.state.purchaseOrderTextGreen}</p> : null}
                      {this.state.purchaseOrderTextRed !== "" ?
                        <p
                          className='  w-fit p-2 rounded-[8px] mt-auto mb-auto'
                          style={{
                            color: "brown",
                            fontSize: "13px",
                            border: "1px solid #a52a2a57",
                            outline: " 2px solid rgb(165 42 42 / 10%)",
                          }}>{this.state.purchaseOrderTextRed}</p> : null}
                    </div>
                  </div>
                </div>
                {/* {this.state.purchaseOrderTextGreen !== "" ? <p
                  className=' mb-3 w-fit p-2 rounded-[8px]'
                  style={{
                    color: "#15803d",
                    fontSize: "13px",
                    border: "1px solid #15803d73",
                    outline: " 2px solid rgb(21 128 61 / 13%)",
                  }}>{this.state.purchaseOrderTextGreen}</p> : null}
                {this.state.purchaseOrderTextRed !== "" ?
                  <p
                    className=' mb-3 w-fit p-2 rounded-[8px]'
                    style={{
                      color: "brown",
                      fontSize: "13px",
                      border: "1px solid #a52a2a57",
                      outline: " 2px solid rgb(165 42 42 / 10%)",
                    }}>{this.state.purchaseOrderTextRed}</p> : null} */}


                <div className="innerTable">
                  <div className="innerTable-container" style={{ height: "calc(100vh - 415px)" }} >
                    <table className="innerList">
                      <thead>
                        <tr>
                          <td style={{ width: '45%' }}>Item Name</td>
                          <td style={{ width: '15%' }}>Batch No</td>
                          <td style={{ width: '10%' }}>Qty</td>
                          <td style={{ width: '10%' }}>Rate</td>
                          <td style={{ width: '10%' }}>Amount</td>
                          <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                        </tr>
                      </thead>
                      {this.state.grnEntryMaterialList && this.state.grnEntryMaterialList.length > 0 ?
                        this.state.grnEntryMaterialList.map((details, key) => (
                          <tbody key={key}>
                            <tr>
                              <td>{this.state.grnRawMaterialPartyDetails.grnEntryType === 'Raw' ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                              <td>{details.batchNo}</td>
                              <td>{details.qty}</td>
                              <td>{details.rate}</td>
                              <td>{details.amount}</td>
                              <td style={{ textAlign: 'center' }}>
                                <button
                                  className="search-btn "
                                  onClick={() => this.getGRNMaterialDetailsById(details)}
                                  disabled={details.isGSTPurchaseEntryRMPM}
                                >
                                  <FontAwesomeIcon className="h-[15px] w-[15px]" icon={faPen} />
                                </button>
                                <button
                                  className="cancel-btn"
                                  onClick={() => this.deleteItemforGRNEntryMaterialById(details._id)}
                                  disabled={details.isGSTPurchaseEntryRMPM}
                                >
                                  <FontAwesomeIcon className="h-[15px] w-[15px]" icon={faTrash} />
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        )) :
                        null
                      }
                    </table>
                  </div>
                </div>

              </div>
            </div>
          ) : null}
        </div>
        <ModalBasic
          id="purchase-order-material-list"

          modalOpen={this.state.setPurchaseMaterialModal}
          setModalOpen={() => this.setOpenModel()}
          title="Material From Purchase Order"
        >
          <div className="itemList-table">
            <div className="table-container">

              <table className="itemList">
                <thead>
                  <tr>
                    <td style={{ width: '10%' }}>Purch. No</td>
                    <td style={{ width: '35%' }}>Party Name</td>
                    <td style={{ width: '35%' }}>Material Name</td>
                    <td style={{ width: '8%' }}>Unit</td>
                    <td style={{ width: '5%' }}>Qty</td>
                    <td style={{ width: '10%', textAlign: 'center' }}>Action</td>
                  </tr>
                </thead>
                {this.state.purchaseOrderMaterialList && this.state.purchaseOrderMaterialList.length > 0 ? (
                  this.state.purchaseOrderMaterialList.map((item, key) => (
                    <tbody key={key}>
                      <tr>
                        <td>{item.purchaseOrderNo}</td>
                        <td>{item.partyName}</td>
                        <td>{item.materialName}</td>
                        <td>{item.materialUOM}</td>
                        <td>{item.materialQty}</td>
                        <td style={{ textAlign: 'center' }}>
                          <button
                            className="search-btn"
                            onClick={() => this.purchaseOrderMaterialDetails(item)}
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  ))
                ) : (
                  <tbody className="validation-body">
                    <tr>
                      <td
                        colSpan={6}
                        style={{ textAlign: "center", fontSize: "16px" }}
                      >
                        No Records Found
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </ModalBasic>
      </>
    );
  }
}

export default GRNRawMaterial;
